import Select from 'react-select';
import {Box, useColorMode, useTheme} from '@chakra-ui/react';
import ClearIndicator from './ClearIndicator';

const Autocomplete = ({ isValid, isDisabled, options, isLoading, setInputValue, onChange, inputValue, setSelectedOption, selectedOption, wrapperProps = {}, ...rest }) => {

    const { colorMode } = useColorMode();
    const theme = useTheme();

    const customStyles = {
        singleValue: (provided) => ({
            ...provided,
            color: 'white',
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            color: 'white',
            borderColor: colorMode === 'dark' ? theme.colors.gray[600] : theme.colors.gray[300],
            boxShadow: 'none',
            height: '54px',
            minHeight: '54px',
            padding: '0 9px 0 16px !important',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '10px',
            border: '1px solid #9FABCB',
            fontSize: '16px',
            fontWeight: '400',
            transition: '0.3s all !important',
            '& > div:first-child': {
                paddingLeft: '0',
            },
            '& input': {
                padding: '0 !important',
                borderRadius: '0 !important',
                border: 'none !important',
                fontSize: 'inherit !important',
                fontWeight: 'inherit !important',
                transition: 'none !important',
                color: 'white !important',

            },
            '& input:focus': {
                boxShadow: 'none !important',
            },

            ...(!state.menuIsOpen && {
                '&:hover': {
                    boxShadow: '0 0 0 0.5px #099BFF !important;',
                    borderColor: '#9FABCB !important',
                }
            }),

            ...(state.menuIsOpen && {
                boxShadow: '0 0 0 0.5px #099BFF !important',
                borderColor: '#099BFF !important',
            }),

        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#0D234D',
            color: 'white',
            zIndex: 100,
            borderRadius: '10px',
            borderWidth: '1px',
            borderColor: '#262D47',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? '#29498F'
              : state.isFocused
                ? '#10337F'
                : '',
            color: 'white',
            padding: '10px 24px',
            fontSize: '14px',
            fontWeight: '400',
            '&:hover': {
                backgroundColor: '#10337F !important',
            },
            '&:active': {
                backgroundColor: '#10337F !important',
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#9FABCB',
            margin: '0',
        }),
        indicatorContainer: (provided) => ({
            ...provided,
            width: '1.5rem',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }),
    };

    const handleSelectChange = (selectedOption) => {
        onChange(selectedOption?.value || selectedOption);
        setSelectedOption(selectedOption);
    };

    return (
      <Box position="relative" {...wrapperProps}>
          <Select
            isDisabled={isDisabled}
            className={'react-select'}
            inputValue={inputValue}
            onInputChange={(value) => {
                setInputValue(value);
                return value;
            }}
            value={selectedOption}
            onChange={handleSelectChange}
            options={options}
            isSearchable
            isLoading={isLoading}
            styles={customStyles}
            isClearable
            {...rest}
            components={{ ClearIndicator, LoadingIndicator: null, IndicatorSeparator: null }}
            selectProps={{
                setSelectedOption,
                setInputValue,
                onChange,
                ...rest,
            }}
          />
          {!isValid && (
            <div className="input-error">
                Input invalid
            </div>
          )}

      </Box>
    );
};

export default Autocomplete;
